/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import 'reflect-metadata';
import '@fontsource/source-code-pro';
import 'typeface-poppins';
import './index.css';
// Import i18n so it is bundled
import './i18n';

import { createRoot } from 'react-dom/client';

import { App } from './App';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');

const root = createRoot(rootElement!);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
